// Reveal-on-scroll, one mechanism for every section (CLAUDE.md rule 0.3).
// Content stays visible without JS; with JS, sections fade and rise once when 15% enters the viewport.
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!('IntersectionObserver' in window) || reduce) return; // leave everything visible
  root.classList.add('fs-js');
  var targets = document.querySelectorAll('.fs-reveal, .fs-reveal-group');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('fs-is-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
  targets.forEach(function (t) {
    var r = t.getBoundingClientRect();
    if (r.top < window.innerHeight * 0.9) t.classList.add('fs-is-visible'); // above the fold: show at once
    else io.observe(t);
  });
})();

(function () {
  var name = function (root) { (root || document).querySelectorAll('input.quantity__input:not([aria-label])').forEach(function (i) { i.setAttribute('aria-label', 'Quantity'); }); };
  var start = function () {
    name();
    var pi = document.querySelector('product-info');
    if (pi && 'MutationObserver' in window) new MutationObserver(function () { name(pi); }).observe(pi, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
